import { render, staticRenderFns } from "./PersonnelRecordEditTabOther.vue?vue&type=template&id=ddc0c9b6"
import script from "./PersonnelRecordEditTabOther.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordEditTabOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports